/**
 * @Author: Zero
 * @Date: 2025-11-10 09:12:16
 * @Explain: 测试玩家管理模块
 */
export default {
  // 测试人列表
  'TESTER.MANAGE.LIST.CREATE': 'Build the tester pool',
  'TESTER.MANAGE.LIST.CREATE.NEW.TESTER': 'Create testers list',
  'TESTER.MANAGE.LIST.COPY.LINK': 'Sign-up/Invite Link',
  'TESTER.MANAGE.LIST.COPY.LINK.PLACEHOLDER': 'Signup link pending',
  'TESTER.MANAGE.LIST.COPY.REDIRECT.PLACEHOLDER':
    'Click to open link in a new tab',
  'TESTER.MANAGE.LIST.COPY.LINK.TIP': 'Copy Sign-up/Invite Link',
  'TESTER.MANAGE.LIST.COPY.LINK.COPY.LINK.SUCCESS': 'Copied successfully',
  'TESTER.MANAGE.LIST.COPY.LINK.COPY.LINK.FAIL': 'Copy link fail',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP':
    'If the invitation process is not configured, the link cannot be copied.',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.TITLE':
    'This link can be used as a <b>Registration Link</b> on official websites and other channels for user sign-ups. When sent via <b>invitation emails</b>, registered users can click to accept the invitation directly.<br/>Note: > Test link configuration <b>must</b> be completed by contacting <a class="account" href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a>. You may refer to the <a class="account font-weight-700" href="{ url }" target="_blank">User Manual</a> for preliminary information.',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.TEXT':
    'After all invited testers click the invitation link, they will enter the following web page process to complete the invitation process. Both this process and its style can be customized.',
  'TESTER.MANAGE.LIST.COPY.LINK.DISABLED.TIP.HEADER.CONTENT':
    'After all invited testers click the invitation link, they will enter the following web page process to complete the invitation process. Both this process and its style can be customized.',
  'TESTER.MANAGE.PLACEHOLDER.CREATE.ENTER.DESCRIPTION': 'Enter description',
  'TESTER.MANAGE.PLACEHOLDER.CREATE.ENTER.NAME': 'Enter name',
  'TESTER.MANAGE.CREATE.ENTER.NAME': 'Name',
  'TESTER.MANAGE.CREATE.ENTER.DESCRIPTION': 'Description',
  'TESTER.MANAGE.CREATE.VERIFY.NAME': 'Name cannot be empty',
  'TESTER.MANAGE.CREATE.VERIFY.NAME.REPEAT': 'Name entered already exists',
  'TESTER.MANAGE.MODAL.TITLE': 'Create testers list',
  'TESTER.MANAGE.EMPTY': 'Welcome to Playtest Hub.',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.MANAGE': 'Build and manage the tester pool',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.INVITATION':
    'Send test invitations and game redemption codes',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.USER':
    "Obtain testers' Discord and Steam accounts",
  'TESTER.MANAGE.EMPTY.EXAMPLE.CONFIDENTIALITY':
    'Sign the NDA confidentiality agreement online',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.Discord':
    'Automatically add testers to the Discord community',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.EASILY.COMPLETE':
    'SmartLink enables you to easily:',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.SUBTITLE':
    'Centrally manage your testers and create an efficient and organized game testing process.',
  'TESTER.MANAGE.EMPTY.EXAMPLE.TEST.TIPS':
    'From recruitment to collaboration, everything is within SmartLink. Make test management more efficient, communication smoother, and the experience more professional.',
  'TESTER.MANAGE.CONFIGURATION.INFORMATION': 'Configuration information',
  'TESTER.MANAGE.CONFIGURATION.INFORMATION.TAG':
    '{tagName} contact is synchronized to the list in one direction, so removing the tag will not affect the contact data in this list',
  'TESTER.MANAGE.TESTER': 'Testers',
  'TESTER.MANAGE.TESTER.NOT.CONFIG': 'Not configured',
  'TESTER.MANAGE.TESTER.INVITATION.JOURNEY': 'invitation journey',
  'TESTER.MANAGE.TESTER.SYNC': 'Contacts are being added....',
  'TESTER.MANAGE.TESTER.NOT.PLAYER.ADD':
    'Currently, there are no testers on the waitlist. Please add some.',
  'TESTER.MANAGE.TESTER.INVITATIONS.PROGRESS': 'Inviting Player....',
  'TESTER.MANAGE.TESTER.INVITATION.PLEASE.COMPLETE.THE': 'Configure ',
  'TESTER.MANAGE.TESTER.LAST.NOT.INVITED': 'No invitations sent out yet',
  'TESTER.MANAGE.TESTER.LAST.INVITED.AT': 'Last invited by {CONTACT} on {DATE}',
  'TESTER.MANAGE.TESTER.LAST.SAVED.AT': 'Last saved by {CONTACT} on {DATE}',
  'TESTER.MANAGE.TESTER.LAST.STATUS': 'Status:',
  'TESTER.MANAGE.LIST.DISCORD.SENTIMENT': 'Sentiment',
  'TESTER.MANAGE.LIST.DISCORD.SENTIMENT.TOOLTIPS':
    'Based on a multilingual NLP sentiment analysis model, each message or comment is assigned a sentiment score: Negative (1 point), Neutral (3 points), Positive (5 points). The aggregated sentiment score is calculated by averaging all individual sentiment scores, ranging from 1 to 5.',
  'TESTER.MANAGE.LIST.CONTRIBUTION': 'Contribution',
  'TESTER.MANAGE.LIST.CONTRIBUTION.TOOLTIPS':
    "Contribution = High-value messages / Total messages. Measures the proportion of a player's meaningful feedback.",
  'TESTER.MANAGE.LIST.STATUS.WAITLIST': 'Waiting',
  'TESTER.MANAGE.LIST.STATUS.INVITED': 'Pending acceptance',
  'TESTER.MANAGE.LIST.STATUS.ACCEPTED': 'Accepted',
  'TESTER.MANAGE.LIST.STATUS.WAITING': 'Waiting',
  'TESTER.MANAGE.LIST.STATUS.ON.BOARDING': 'Accepted',
  'TESTER.MANAGE.LIST.STATUS.INVITE.LINK': ' Invite link',
  'TESTER.MANAGE.LIST.STATUS.INVITE.EMAIL': 'Invite email',
  'TESTER.MANAGE.LIST.STATUS.ON.BOARDING.EMAIL': 'Accepted email',
  'TESTER.MANAGE.LIST.STATUS.WAITLIST.NOTES':
    'Contact has been added to the testers list.',
  'TESTER.MANAGE.LIST.STATUS.INVITED.NOTES':
    'The invitation email has been sent to the tester.',
  'TESTER.MANAGE.LIST.STATUS.ACCEPTED.NOTES':
    "When contacts complete the preset actions in the invitation link (customizable), their status changes to 'Accepted'.",
  'TESTER.MANAGE.LIST.STATUS.TITLE': 'Status',
  // 测试人列表-按钮相关
  'TESTER.MANAGE.LIST.EDIT': 'Edit',
  'TESTER.MANAGE.LIST.CONFIGURE': 'Set',
  'TESTER.MANAGE.LIST.VIEW.DETAILS': 'Testers lists',
  'TESTER.MANAGE.LIST.AI.ANALYTICS': 'AI Analytics',

  // 邀请旅程
  'TESTER.MANAGE.LIST.INVITATION JOURNEY': 'Invitation journey',
  // 旅程状态文本
  'TESTER.MANAGE.LIST.STATUS.EDIT': 'Edit',
  'TESTER.MANAGE.LIST.STATUS.SUSPEND': 'Suspend',
  'TESTER.MANAGE.LIST.STATUS.DETAILS': 'Details',
  'TESTER.MANAGE.LIST.STATUS.REVIEWS.ERROR': 'Reviews error',

  // 测试管理列表
  'TESTER.MANAGE.TEST.LIST.FILTERS.MY.NO.REGION': 'No Regions here',
  // Top filter bar - add condition menu & labels
  'TESTER.MANAGE.TEST.LIST.FILTERS.ADD.CONDITION': 'Add condition',
  'TESTER.MANAGE.TEST.LIST.FILTERS.EMAIL': 'Email',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM': 'Steam',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.KEY': 'Steam key',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.ID': 'Steam ID',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.ID.FILLED': 'Filled in',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.ID.NOT.FILLED': 'Not filled in',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.ID.SEARCH': 'Search',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PSN.ID.HAS.VALUE': 'Has value',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PSN.ID.NO.VALUE': 'No value',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PSN.ID.SEARCH': 'Search',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PLAYTIME': 'Playtime',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.WISHLIST': 'Steam wishlist',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DISCORD': 'Discord',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DISCORD.USERNAME': 'Discord username',
  'TESTER.MANAGE.TEST.LIST.FILTERS.SENTIMENT': 'Sentiment',
  'TESTER.MANAGE.TEST.LIST.FILTERS.CONTRIBUTION': 'Contribution',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PLAYER.INFO': 'Player info',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.TITLE': 'Region',
  'TESTER.MANAGE.TEST.LIST.FILTERS.LANGUAGE': 'Language',
  // 按钮部分
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.ALL.TESTERS': 'All Players: ',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.SHOWING.L': '',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.SHOWING.R':
    ' players match the filter criteria',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.CLEAR.FILTERS': 'Clear Filter',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.SELECTED': 'selected',
  'TESTER.MANAGE.TEST.LIST.TOP.ACTION.CLEAR.SELECTED': 'Clear Selection',
  // string 型 survey 动态筛选通用选项文案
  'TESTER.MANAGE.TEST.LIST.FILTERS.STRING.HAS.VALUE': 'Has value',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STRING.NO.VALUE': 'No value',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STRING.SEARCH': 'Search',
  'TESTER.MANAGE.TEST.LIST.FILTERS.SUBSCRIPTION.STATUS': 'Subscription status',
  'TESTER.MANAGE.TEST.LIST.FILTERS.TIME.ADDED': 'Time added',
  'TESTER.MANAGE.TEST.LIST.FILTERS.TIME.INVITED': 'Time invited',
  'TESTER.MANAGE.TEST.LIST.FILTERS.TIME.ACCEPT': 'Accepted invitation time',
  'TESTER.MANAGE.TEST.LIST.FILTERS.INVITED.FRIENDS.COUNT': 'Invited friends',
  'TESTER.MANAGE.TEST.LIST.FILTERS.BAN.STATUS': 'Ban status',
  'TESTER.MANAGE.TEST.LIST.FILTERS.BAN.STATUS.BANNED': 'Banned',
  'TESTER.MANAGE.TEST.LIST.FILTERS.BAN.STATUS.UNBANNED': 'Unbanned',
  // Ban/Unban related
  'TESTER.MANAGE.BAN.BUTTON.BANNED': 'Banned',
  'TESTER.MANAGE.BAN.BUTTON.UNBAN': 'Unban',
  'TESTER.MANAGE.BAN.BUTTON.UNBAN.TIPS1':
    'Only one player can be unbanned at a time.',
  'TESTER.MANAGE.BAN.AND.UNBAN.TIPS':
    'Cross-page selection detected. The system cannot verify the actual number of selected players. Please select only one player on the current page before proceeding.',
  'TESTER.MANAGE.BAN.DIALOG.TITLE':
    'Are you sure you want to ban this test player?',
  'TESTER.MANAGE.BAN.DIALOG.TITLE.PLURAL': 'Ban Test Players from Playtest',
  'TESTER.MANAGE.BAN.DIALOG.CONTENT.LINE1':
    'Once banned, the player will no longer be able to complete registration or accept invitations.',
  'TESTER.MANAGE.BAN.DIALOG.CONTENT.LINE2':
    'If the player has already joined the Discord server, they will also be banned from the server.',
  'TESTER.MANAGE.BAN.DIALOG.CONFIRM.TIP':
    '<b class="color-333"><span class="color-error">{name}</span> will be banned</b>',
  'TESTER.MANAGE.BAN.DIALOG.CONFIRM.LABEL': 'Type',
  'TESTER.MANAGE.BAN.DIALOG.CONFIRM.KEYWORD': 'BAN',
  'TESTER.MANAGE.BAN.DIALOG.CONFIRM.SUFFIX': 'to confirm',
  // 'TESTER.MANAGE.BAN.DIALOG.SYNC.INFO':
  //   'The banned status will be synced to other tests in the Player Testing Center.',
  'TESTER.MANAGE.BAN.SUCCESS': 'Banned successfully',
  'TESTER.MANAGE.UNBAN.DIALOG.TITLE': 'Unban this player?',
  'TESTER.MANAGE.UNBAN.DIALOG.CONTENT.LINE1':
    "Once unbanned, the player's registration or invitation links will be reactivated, and the server ban will be lifted.",
  // 'TESTER.MANAGE.UNBAN.DIALOG.CONTENT.LINE2':
  //   "The contact's ban status in the Discord server will also be lifted.",
  'TESTER.MANAGE.UNBAN.SUCCESS': 'Unbanned successfully',
  // Top filter bar - options & placeholders
  'TESTER.MANAGE.TEST.LIST.FILTERS.STATUS.PLACEHOLDER': 'Status',
  // Top tag filter placeholder
  'TESTER.MANAGE.TEST.LIST.FILTERS.TAG.PLACEHOLDER': 'Tags',
  // Common placeholder for filter dropdowns / cascader / date range
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.PLACEHOLDER': 'Please select',
  // Range condition min/max prefix (concatenated with unit, e.g. "Min min(s)")
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.MIN': 'Min',
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.MAX': 'Max',
  // Score-type ranges (sentiment / contribution)
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.MIN.SCORE': 'Min high-value',
  'TESTER.MANAGE.TEST.LIST.FILTERS.COMMON.MAX.SCORE': 'Max high-value',
  // Range input incomplete warning
  'TESTER.MANAGE.TEST.LIST.FILTERS.RANGE.INCOMPLETE.WARNING':
    'Please complete the score range (both Min and Max scores are required).',
  'TESTER.MANAGE.TEST.LIST.FILTERS.GAMETIME.RANGE.INCOMPLETE.WARNING':
    'Please enter a complete duration range (both Min and Max duration are required).',
  'TESTER.MANAGE.TEST.LIST.FILTERS.INVITED.FRIENDS.RANGE.INCOMPLETE.WARNING':
    'Please enter a complete friends count range (both Min and Max are required).',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PLAYTIME.UNIT.MIN': 'min(s)',
  'TESTER.MANAGE.TEST.LIST.FILTERS.PLAYTIME.UNIT.HOUR': 'hour(s)',
  'TESTER.MANAGE.TEST.LIST.FILTERS.WISHLIST.AVAILABLE': 'Added',
  'TESTER.MANAGE.TEST.LIST.FILTERS.WISHLIST.NO.DATA': 'Not added',
  'TESTER.MANAGE.TEST.LIST.FILTERS.WISHLIST.PRIVATE': 'Private',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SEARCH.ZONE.PLACEHOLDER':
    'Search zone',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SEARCH.REGION.PLACEHOLDER':
    'Search region(s)',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SELECT.TIP':
    '* Select relevant option(s)',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SUBTITLE': 'Region(s)',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.NO.DATA': 'No data',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.NO.REGIONS': 'No regions',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.SELECT.ZONE.FIRST':
    'Select a zone first',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.START.END':
    'Start date  -  End date',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.7.DAYS': 'Last 7 days',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.14.DAYS': 'Last 14 days',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.30.DAYS': 'Last 30 days',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.90.DAYS': 'Last 90 days',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.LAST.180.DAYS': 'Last 180 days',
  'TESTER.MANAGE.TEST.LIST.FILTERS.DATE.RANGE.ALL.OF.TIME': 'All of time',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.KEY.STATUS.REDEEMED': 'Redeemed',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.KEY.STATUS.UNREDEEMED': 'Unredeemed',
  'TESTER.MANAGE.TEST.LIST.FILTERS.STEAM.KEY.STATUS.FETCHING': 'Fetching',
  'TESTER.MANAGE.TEST.LIST.REGION': 'Regions',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GROUP.TITLE': 'Regions',
  'TESTER.MANAGE.TEST.LIST.REGION.CUSTOM.AREA.GROUP.TITLE': 'Zone',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.L':
    "Create a new zone and move regions from 'Others' to this new zone.<br/>Adjust zones and regions in ",
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.C': 'Region management',
  'TESTER.MANAGE.TEST.LIST.FILTERS.REGION.GO.R': '.',
  'TESTER.MANAGE.TEST.LIST.EDIT.TESTER.CONFIRM.BTN.TEXT': 'Save',
  // 修改测试人列表-标题
  'TESTER.MANAGE.TEST.LIST.EDIT.TESTER.TITLE': 'Edit tester list',
  'TESTER.MANAGE.TEST.LIST.TITLE': 'Testers list',
  'TESTER.MANAGE.TEST.LIST.TITLE.NO.TESTERS.YET': 'No testers yet.',
  'TESTER.MANAGE.TEST.LIST.SEARCH.NAME.PLACEHOLDER': 'Search tester email',
  'TESTER.MANAGE.TEST.LIST.SEARCH.STATUS': 'Status',

  // 邀请按钮
  'TESTER.MANAGE.TEST.LIST.INVITE.WAITING.TESTER': 'Pending Invitations',
  'TESTER.MANAGE.TEST.LIST.INVITE.WAITING.TESTER.NUM': ' ({num})',
  // 删除相关的按钮
  'TESTER.MANAGE.TEST.LIST.REMOVE.CONTACTS': 'Remove testers',
  'TESTER.MANAGE.TEST.LIST.REMOVE.CONTACTS.TIPS1':
    'Only non-banned players with pending invitations can be removed.',
  'TESTER.MANAGE.TEST.LIST.CONFIRM.REMOVE': 'Confirm removal',
  'TESTER.MANAGE.TEST.LIST.DELETING.TIP': 'Removing...',
  'TESTER.MANAGE.TEST.LIST.DELETING.PROGRESS': 'Removing Player....',
  // 展示对应的游戏的头像和名称
  'TESTER.MANAGE.TEST.LIST.PLATFORM.SOURCE': 'Connected source:',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.NOT.LINKED': 'None',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.NOT.LINKED.TIPS':
    'No {platform} game linked yet',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.STEAM.LINKED':
    'Tracks: Playtime, Wishlist status by Steam APl.',
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.LINKED':
    'Analyzes: Sentiment & Contribution from live chat logs.',
  // Multi-channel display when AI analytics is configured with multiple Discord channels
  // Trigger label after the server name in the top-right corner
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.MULTIPLE.CHANNELS':
    'Source channels ({count})',
  // Hover popup title: analysis scope label
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.ANALYZE.SCOPE.TITLE':
    'Analysis scope:',
  // Hover popup title description
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.ANALYZE.SCOPE.DESC':
    'Sentiment & contribution score analyzed from live chat logs.',
  // Hover popup list subtitle: Source channels (N):
  'TESTER.MANAGE.TEST.LIST.PLATFORM.DISCORD.SOURCE.CHANNELS':
    'Source channels ({count}):',
  // Steam ID
  'TESTER.MANAGE.TEST.LIST.TABLE.STEAM.ACCOUNT.ID': 'Steam ID',
  // 添加联系人
  'TESTER.MANAGE.TEST.LIST.AddCONTACT': 'Add testers',
  'TESTER.MANAGE.TEST.LIST.DIALOG.HEADER.ADD.TESTER': 'Add testers',
  'TESTER.MANAGE.TEST.LIST.DIALOG':
    'Adds existing contacts with the selected tags. Re-select the tag here anytime to sync new contacts.',
  'TESTER.MANAGE.TEST.LIST.DIALOG.SELECT.PLACEHOLDER': 'Select tag(s)',
  // 删除联系人 二次弹窗
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.TITLE':
    'Are you sure you want to remove the selected test players?',
  // 删除联系人 二次弹窗内容文本
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.CONTENT':
    'After removal, the selected players will no longer be synced to this list.',
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.TIP':
    '<span class="color-666">To be</span> <b class="color-333 font-weight-700">removed:</b> <b class="color-333 font-weight-700 font-size-32"  style="margin-bottom: -4px; display: inline-block; vertical-align: bottom;">{num}</b>',
  // 删除联系人 二次弹窗内容文本-确认文本
  'TESTER.MANAGE.TEST.LIST.DIALOG.DELETE.CONFIRM.BTN.TEXT': 'Confirm',
  'TESTER.MANAGE.TEST.LIST.DIALOG.SELECTED.PLAYERS':
    '<b>{CONTACTS} tester(s)</b> have been selected.',
  'TESTER.MANAGE.TEST.LIST.DIALOG.EMAIL.SUBSCRIBERS': 'email subscribers',
  'TESTER.MANAGE.TEST.LIST.DIALOG.EMAIL.CONTACTS': 'email contacts',
  // 同步联系人 message
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT': '{CONTACT} contacts have been added',
  'TESTER.MANAGE.TEST.LIST.SYNC.ZERO.CONTACT':
    'There are no subscribed contacts that can be newly added under this tag.',
  'TESTER.MANAGE.TEST.LIST.DISABLED.TOOLTIP.ADDING':
    'Contacts are being added....',
  // 轮询 接口 数据被删除 返回列表页 文案
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.DATA.DELETE.TITLE': 'Test deleted',
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.DATA.DELETE':
    'Please go back to the list.',
  // 同步联系人百分比
  'TESTER.MANAGE.TEST.LIST.SYNC.CONTACT.PROGRESS': 'Data reading',
  // 确认邀请按钮文案
  'TESTER.MANAGE.TEST.LIST.CONFIRM.INVITATION': 'Confirm invitation',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION':
    'Invite the selected test players?',
  // 'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.SUBSCRIBERS.ON.THE.WAITLIST':
  //   'Selected',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.SUBSCRIBERS': 'Invitees',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT':
    'After confirmation, these players will officially enter the invitation journey.',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TIPS':
    'The system will only invite players who are in a pending invitation state and have already subscribed',
  // 旅程详情跳转
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT.JOURNEY.DETAILS':
    'Journey Details',
  'TESTER.MANAGE.TEST.LIST.SEND.AN.INVITATION.TEXT.TAGS':
    'The tags added here will be automatically bound to contacts after they are invited.',
  // 表头相关
  'TESTER.MANAGE.TEST.LIST.TABLE.SUBSCRIPTION.STATUS': 'Subscription status',
  'TESTER.MANAGE.TEST.LIST.TABLE.REGION': 'Region',
  'TESTER.MANAGE.TEST.LIST.TABLE.LANGUAGE': 'Language',
  'TESTER.MANAGE.TEST.LIST.TABLE.TAGS': 'Tags',
  'TESTER.MANAGE.TEST.LIST.TABLE.AUTHORIZATION.PLATFORM':
    'Authorization platform',
  'TESTER.MANAGE.TEST.LIST.TABLE.JOINED.LIST': 'Date added',
  'TESTER.MANAGE.TEST.LIST.TABLE.INVITED.TIME': 'Invitation sent',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONBOARDING.TIME': 'Accepted invitation time',
  'TESTER.MANAGE.TEST.LIST.TABLE.INVITED.FRIENDS.COUNT': 'Invited friends',
  'TESTER.MANAGE.TEST.LIST.TABLE.START.TIME': 'From',
  'TESTER.MANAGE.TEST.LIST.TABLE.END.TIME': 'Until',
  'TESTER.MANAGE.TEST.LIST.TABLE.STATUS': 'Status',
  'TESTER.MANAGE.TEST.LIST.TABLE.EMAIL': 'Email',
  'TESTER.MANAGE.TEST.LIST.TABLE.SUBSCRIBED': 'Subscribed',
  'TESTER.MANAGE.TEST.LIST.TABLE.PENDING': 'Pending',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNSUBSCRIBED': 'Unsubscribed',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNKNOWN': 'Non-subscribed',
  'TESTER.MANAGE.TEST.LIST.TABLE.UNBOUND': 'Unbound',
  'TESTER.MANAGE.TEST.LIST.TABLE.DRAFT': 'Draft',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONGOING': 'Ongoing',
  'TESTER.MANAGE.TEST.LIST.TABLE.ONGOING.JOURNEY.ERROR':
    'Ongoing journey error',
  'TESTER.MANAGE.TEST.LIST.TABLE.SUSPENDED': 'Suspended',
  'TESTER.MANAGE.TEST.LIST.TABLE.TOTAL.COUNT': 'Total testers:{recordCount}',
  // 请求相关的提示
  'TESTER.MANAGE.TEST.LIST.INVITATION.COMPLETE': 'Invitation sent',
  'TESTER.MANAGE.TEST.LIST.INVITATION.FAILED': 'Invitation failed to send',
  'TESTER.MANAGE.TEST.LIST.DELETE':
    '{deleteTesterNums} testers have been successfully removed.',
  'TESTER.MANAGE.TEST.LIST.EDIT.INFO': 'Edit succeed',
  'TESTER.MANAGE.TEST.LIST.IMPORT.CONTACT': 'Success',
  'TESTER.MANAGE.TEST.LIST.CREATED.INFO': 'Success',
  'TESTER.MANAGE.TEST.LIST.PLAYER ENTERED INVITATION JOURNEY':
    'Player entered invitation journey',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY': 'Steam key',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.NOT.SENT': '/',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.FETCHING': 'Loading',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.NOT.EXCHANGED': 'Unclaimed',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.EXCHANGED': 'Claimed',
  'TESTER.MANAGE.TEST.LIST.STEAM.KEY.LAST.UPDATED.AT':
    'Last Updated {updateTime}',
  // 引导内容
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TITLE': 'Playtest User Guide',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP1.TITLE':
    'Registration & Invitation Setup (Ops Support)',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP1':
    "<span class='guide-content'><span class='guide-content-text'><b>Customization: </b>Tailor the copy and visual styles within the standard flow to create a branded onboarding experience. Please contact <a  href='mailto:SmartLink_service@proximabeta.com'>SmartLink_service@proximabeta.com</a>  for configuration assistance.</span></span><br/><span class='guide-content'><span class='guide-content-text'><b>Platform Integration: </b>To retrieve player authentication data from Steam or Discord, you must provide the respective platform's authorization credentials (refer to the <a href='https://docs.smartlink.intlgame.com/function-guide/manage-playtesthub-configuration/' target='_blank'>Playtest Configuration Manual for details</a>).</span></span><br/><span class='guide-content'><span class='guide-content-text'><b>Data Collection & Tagging: </b>Collect player profiles via built-in questionnaires and set up custom tags to precisely track player sources.</span></span>",
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP2.TITLE':
    'Player Acquisition & Import',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP2':
    '<span class="guide-content"><span class="guide-content-text"><b>Omnichannel Auto-Sync: </b>Deploy registration links across external channels such as official websites. players who sign up via these links will be automatically synced to both the Tester List and Contact List.</span></span><br/><span class="guide-content"><span class="guide-content-text"><b>Tag-Based Bulk Import: </b>In the Tester List view, use the "Add Tester" function to batch import players by filtering specific tags.</span></span>',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP3.TITLE':
    'Testing Journey Configuration (Prerequisites)',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP3':
    '<span class="guide-content"><span class="guide-content-text"><b>Journey Setup: </b>Once invited, players will automatically progress through the predefined journey flow. Please ensure the journey is fully configured and published before sending invitations.</span></span><br/><span class="guide-content"><span class="guide-content-text"><b>Access Point: </b>Click the "Edit" button within the Tester List to access the visual workflow builder.</span></span>',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP4.TITLE': 'Sending Invitations',
  'TESTER.MANAGE.TEST.LIST.PLAYER.GUID.TIP4':
    '<span class="guide-content"><span class="guide-content-text"><b>Prerequisite: </b>Ensure the associated testing journey is fully configured and ready before sending invites.</span></span><br/><span class="guide-content"><span class="guide-content-text"><b>Invitation Workflow:</b></span></span><br/><span class="guide-content guide-content-child"><span class="guide-content-text guide-content-child-text"><span class="color-333">Unregistered Players: </span>Upon receiving an invitation email, players must first complete the registration process before accepting the invitation</span></span><br/><span class="guide-content guide-content-child"><span class="guide-content-text guide-content-child-text"><span class="color-333">Registered Players: </span>Players can directly accept the invitation and proceed.</span></span>',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.COLUMN': 'Columns',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.COLUMN.SELECT': 'Select columns to display',
  'TESTER.MANAGE.TEST.LIST.TOOLTIP.APPLY': 'Apply',
  'TESTER.MANAGE.TEST.LIST.BAN.TITLE': 'Ban',
  'TESTER.MANAGE.TEST.LIST.BAN.TITLE.TIPS1':
    'Only one player can be banned at a time.',

  // 测试配置
  'TESTER.MANAGE.CONFIG.EDIT.NAME': 'Edit name & description',
  'TESTER.MANAGE.CONFIG.SELECT.CONTACTS.LABEL':
    '1、Includes contacts who match all selected tags.',
  'TESTER.MANAGE.CONFIG.SELECT.CONTACTS.PLACEHOLDER':
    '标签下的联系人会自动加入到测试列表',
  'TESTER.MANAGE.CONFIG.TEST': '2、Test configure',
  'TESTER.MANAGE.CONFIGURED': '已配置',
  'TESTER.MANAGE.NOT.CONFIGURED': '未配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.TITLE': '受邀流程配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.DESC':
    '此链接提供协议签署、绑定discord 或 steam的玩家受邀流程，请联系 XXXX@XXXX.com完成测试链接配置。',
  'TESTER.MANAGE.CONFIG.TEST.INVITED.LINK.COPY': '复制链接',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.TITLE': '邀请邮件配置',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.DESC':
    '请将第一步配置好的受邀流程链接粘贴到邮件模板中。<br/>联系人通过邀请邮件，接受测试邀请。',
  'TESTER.MANAGE.CONFIG.TEST.INVITATION.SENTING.TIPS':
    'The email is being sent; settings cannot be changed',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.TITLE': '资源码邮件配置',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.DESC':
    '联系人通过邀请邮件，接受测试邀请。<br/>联系人接受邀请，完成邀请流程后，系统会自动为联系人发送资源码邮件。',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.NUM': '资源码数量：{num}',
  'TESTER.MANAGE.CONFIG.TEST.RESOURCE.UPLOAD': '上传',
  'TESTER.MANAGE.CONFIG.LEAVE.TITLE':
    'Do you want to save the changes you have made?',
  'TESTER.MANAGE.CONFIG.LEAVE.DESC':
    'Here is subtitle description description description description',
  'TESTER.MANAGE.CONFIG.SAVE.TITLE': 'Confirm to save the configuration?',
  'TESTER.MANAGE.CONFIG.SAVE.DESC':
    '<p>Confirm and save the configuration; contacts within the tags will be automatically synchronized to the configuration management page.</p><p style="margin-top: 16px;">You can enter the configuration management page to send invitations to contacts</p>',
  'TESTER.MANAGE.CONFIG.SAVE.GO.TESTER': 'Save and return test list',
  'TESTER.MANAGE.CONFIG.SAVE.GO.TEST': 'Save and enter test management',

  /** 删除弹窗 */
  'TESTER.MANAGE.DELETE.TITLE': 'Confirm deletion of testers list?',
  'TESTER.MANAGE.DELETE.DESC':
    'After deleting {tester}, the  testers list cannot be recovered.',

  'TEST.MANAGE.AI.ANALYTICS.DISABLED.TOOLTIP':
    'Please contact <a href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a> to complete the configuration of Discord.',
  'TEST.MANAGE.AI.ANALYTICS.NOT.CONFIGURED.TOOLTIP':
    'Configuration incomplete. Please contact <a href="mailto:SmartLink_service@proximabeta.com">SmartLink_service@proximabeta.com</a> to complete the setup.',
  'TESTER.MANAGE.BIND': 'Linked',
  'TESTER.MANAGE.UNBIND': 'Unlinked',
  // Timeline - ban/unban
  'TESTER.MANAGE.TIMELINE.BAN.TESTER':
    '<b style="color:#000">Player Testing Center</b> - Test {testerName}: The contact was banned by Account {createdBy}.',
  'TESTER.MANAGE.TIMELINE.BAN.DISCORD':
    'Discord Server {discordServerName}: This user has been banned.',
  'TESTER.MANAGE.TIMELINE.UNBAN.TESTER':
    '<b style="color:#000">Player Testing Center</b> - Test {testerName}: The contact was unbanned by {createdBy}.',
  'TESTER.MANAGE.TIMELINE.UNBAN.DISCORD':
    'Discord Server {discordServerName}: This user has been unbanned.',

  // 二次确认邮件
  'TESTER.MANAGE.OPTIN.STRATEGY.SET': 'Double Opt-in Settings',
  'TESTER.MANAGE.OPTIN.STRATEGY.NAME':
    'Double Opt-in Settings - {testerManageName}',
  'TESTER.MANAGE.OPTIN.STRATEGY.DESC':
    'Set whether contacts receive a confirmation email after registering for a test',
  'TESTER.MANAGE.OPTIN.STRATEGY.METHOD.SINGLE.DESC':
    'Contacts who join the system for the first time via a test/form can have their subscription status directly updated to "Subscribed" without requiring a secondary confirmation email. This approach maximizes list growth speed.',
  'TESTER.MANAGE.OPTIN.STRATEGY.METHOD.DOUBLE.PARTICULAR.DESC1':
    'Contacts who join the system for the first time via a test/form must be verified through a confirmation email before being officially subscribed. Prior to confirmation, their subscription status is set to "Pending". This mode is automatically enabled for users in specific countries/regions to help you comply with local legal requirements, while streamlining the subscription process for users in other regions.',
  'TESTER.MANAGE.OPTIN.STRATEGY.METHOD.DOUBLE.ALL.DESC1': `Regardless of region, all contacts who join the system for the first time via a test/form must be verified through a confirmation email. Prior to confirmation, their subscription status is set to "Pending". This approach ensures the highest quality contact list and explicitly obtains the user's subscription consent.`,
  'TESTER.MANAGE.OPTIN.SAVE': 'Save Configuration',

  // 报表分类
  'TESTER.MANAGE.REPORT.CATEGORY': 'Game test list',
};
